module.exports = __webpack_public_path__ + "img/gkrymscs.771cb241.png";